var _a;
/**
 * @hidden
 */
export var separatorAriaMessage = 'drawer.separatorAriaMessage';
/**
 * @hidden
 */
export var splitterPaneLabel = 'splitter.splitterPaneLabel';
/**
 * @hidden
 */
export var messages = (_a = {},
    _a[separatorAriaMessage] = 'Separator',
    _a[splitterPaneLabel] = 'Splitter pane',
    _a);
